import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { bdsGridModeType } from '@bds/components';
import { RailtracReportsService } from '../../railtrac-reports.service';
import { PageService } from '@bds/core';
import { ReportConstants } from '../../models/report-parameters.model';

@Component({
    selector: 'lib-origin-performance',
    templateUrl: './origin-performance.component.html',
    styleUrl: './origin-performance.component.css',
})
export class OriginPerformanceComponent implements OnInit {
    public gridId = 134;
    public gridMode: bdsGridModeType = 'single';
    public apiCall: string = ReportConstants.ReportDataApiCall;
    public pageHeader: string = 'Origin Performance Report';
    public gridSource: any;
    public totalCount: number = 0;

    constructor(public reportService: RailtracReportsService, public pageService: PageService) {}

    ngOnInit() {
        this.pageService.setHeader(this.pageHeader);
        this.gridSource = this.reportService.CreateAspNetDatastore(
            this.apiCall,
            this.gridId.toString(),
        );
    }

    onContentReady(e: any) {
        if (e.component) {
            const dataSource = e.component.getDataSource();
            if (dataSource) {
                this.totalCount = dataSource.totalCount() || 0;
            }
        }
    }

    customizeColumns = (columns: any[]) => {
        const datePipe = new DatePipe('en-US');
        const shipCol = columns.find((c: any) => c.dataField === 'ship_date_time');
        if (shipCol) {
            shipCol.dataType = 'date';
            shipCol.calculateDisplayValue = (rowData: any) => {
                const value = rowData['ship_date_time'];
                return value ? datePipe.transform(value, 'MM/dd/yyyy', 'UTC') : '';
            };
        }
        ['clm_date_time', 'orig_eda_eta_cust'].forEach((field) => {
            const col = columns.find((c: any) => c.dataField === field);
            if (col) {
                col.dataType = 'datetime';
                col.calculateDisplayValue = (rowData: any) => {
                    const value = rowData[field];
                    return value ? datePipe.transform(value, 'MM/dd/yyyy HH:mm', 'UTC') : '';
                };
            }
        });
    };
}
